export function serializer(string: string) {
  const specialCaracs = /[!"`’'#%&,:;<>=@{}~$()*+/?[\]^|]+/gi;
  const stringSerialized = string
    ?.toLowerCase()
    .replace(/ /g, '-')
    .replace(specialCaracs, '');

  return stringSerialized;
}
